module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_3009.c6e715a3.png";